/**
 * NOTE: Be extremely careful when dealing with types as this is a sensitive
 * mix between frontend, Revbell and Connectors.
 */

import { GenericObject } from "../services/Price";
import { Field } from "./Service/interfaces";

/**
 * User interface representing a user entity
 *
 * For now this interface presents some flows due to source
 * of data that can be either Revbell or Connector.
 * I need to find a way to unify both sources.
 */
export interface User {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  username: string;
  is_active: boolean;
  is_staff: boolean;
  is_superuser: boolean;
  date_joined: string;
  last_login: string | null;
}

/**
 * Property interface representing a property entity
 *
 * For now this interface presents some flows due to source
 * of data that can be either Revbell or Connector.
 * I need to find a way to unify both sources.
 */
export interface Property {
  id: number;
  hebergement_geo_zone1_id: number | null;
  hebergement_groupe1_id: number | null;
  analyste_id: User | null;

  code: string;
  short_name: string;
  name: string;
  hebergement_nom_court: string;
  // TMP: to be removed when connector will fully handle the return

  nb_etoiles: number | null;
  vat_rate_pct: number | null;

  created_at: string;
  updated_at: string;

  // PropertyMeta
  selected?: boolean;
}

export interface Connector {
  version: number;
  params: Field[];
  // params: Record<string, Field[]>;

  // TODO create an enum for attributes
  attributes: GenericObject;
}

/**
 * Service interface representing the service_client entity
 */
export interface Service {
  id: number;
  service: string;
  version: number;
  is_pending?: boolean; // Indicates if the connector is in the process of being created
  is_active: boolean | null;
  enable_updates: boolean | null;
  enable_restriction_updates: boolean | null;
  enable_yieldclass_updates: boolean | null;
  execution_priority?: number | null;
  params: GenericObject;
  created_at?: string;
  updated_at?: string;
  created_by?: User;
  updated_by?: User;

  // Daily counts of successful PMS pushes over the last 7 days.
  // Length 7, ordered oldest → newest (today-6 … today), zero-filled for
  // missing days. Populated by the listing endpoint.
  prices_sent_last_7d?: number[];
  restrictions_sent_last_7d?: number[];

  properties?: Property[];

  // Whether the connectors' nightly run starts this row (etl rows, active
  // v2 core rows). Set by the listing endpoint; read by the "run now" button.
  runs_nightly?: boolean;

  schema: string; // DB property: etl or core

  // Computed fields
  connector?: Connector;
}

export enum ConfigurationModes {
  OVERVIEW = "overview",
  LOGS = "logs",
  TRANSACTIONS = "transactions",
  CREATION = "creation",
  PARAMS = "params",
  META = "meta",
  PROPERTIES = "properties", // NOTE: moved in meta; TODO: to be removed
  UH_CATS = "uh_cats",
}

// TODO delete
// TODO It might be better to have different names for actions and states
// Eg. cancel/cancelled - submit/submitted
export type DetailsState =
  | "initial"
  | "new_service_init"
  | "new_service_loading"
  | "new_service_ready"
  | "new_service_cancel"
  | "new_service_test"
  | "new_service_submit"
  | "new_service_terminated"
  | "params_init"
  | "params_ready"
  | "params_edit"
  | "params_submit"
  | "params_submitted"
  | "params_loading"
  | "params_cancel"
  | "params_cancelled"
  | "meta_init"
  | "meta_ready"
  | "meta_edit"
  | "meta_submit"
  | "meta_submitted"
  | "meta_loading"
  | "meta_cancel"
  | "meta_cancelled";

/**
 * ContextBatch interface representing the context of a batch operation
 *
 * Batch management will the object of a future evolution to better handle
 * the states, errors, feedbacks, and prevent concurrent batches.
 */
export interface ContextBatch {
  service?: string;
  status?: string;
  batch?: GenericObject;
  task?: GenericObject;
}
